





// import
import {
  Box,
  Button,
  CircularProgress,
  TextField,
  Typography,
} from '@mui/material';
import CustomText, { textStyles } from "../../../components/CustomText";
import BaseCard from '../../../components/Cards/Card';
import { useTheme } from "@mui/material/styles";
import useMediaQuery from '@mui/material/useMediaQuery';
import { toast, Toaster } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import verify from "../../../assets/verify.svg";
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useRef, useState } from 'react';
import { BASE_URL } from '../../../components/BaseUrl';
import { setOtpData, setResetToken } from '../../../Redux/Slices/AuthSlice';
import { useLocation } from 'react-router-dom';
import {  useSearchParams } from "react-router-dom";
import { setInviteProfileUpdateToken,setProfileUpdateToken } from "../../../Redux/Slices/AuthSlice";
import { showToast } from '../../../Utlis/messageHandler';
const ModalVerify = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
 const [searchParams] = useSearchParams();
  const userId = searchParams.get("userId");
  const token = searchParams.get("token"); // ✅ read from URL

  const [otpInput, setOtpInput] = useState(["", "", "", "", "", ""]);
  const [isVerifying, setIsVerifying] = useState(false);
  const [isResending, setIsResending] = useState(false);
  const [seconds, setSeconds] = useState(0);
  const [otpError, setOtpError] = useState(false); // 👈 NEW state for error border
  const inputRefs = useRef([]);

  const { otpData } = useSelector((state) => state.auth);
  // const email = otpData?.email;
  const location=useLocation()
  const email = otpData?.email || location.state?.email;
  const otp = otpData?.otp;
const from = location.state?.from;

  useEffect(() => {
    let timer;
    if (seconds > 0) {
      timer = setTimeout(() => setSeconds(prev => prev - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [seconds]);

  const handleChange = (index, value) => {
    const newOtp = [...otpInput];
    newOtp[index] = value.slice(-1);
    setOtpInput(newOtp);
    setOtpError(false); // reset error when user types
    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otpInput[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };
const handleVerify = async () => {
  console.log("🚀 handleVerify triggered");

  const finalOtp = otpInput.join("");
  if (finalOtp.length !== 6) {
    setOtpError(true);
     showToast(toast.error, {
      message_en: t("alerts.otpInvalid6Digit"),
      message_es: t("alerts.otpInvalid6Digit")
    });
    return;
  }

  console.log("👉 userId:", userId);
  console.log("👉 OTP typed:", finalOtp);

  setIsVerifying(true);

  try {
    const url = `${BASE_URL}/public/account-executives/verify-invite?userId=${userId}&otp=${finalOtp}`;
    console.log("🔍 Fetching:", url);

    const response = await fetch(url, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });

    console.log("📡 Raw response status:", response.status);

    const data = await response.json();
    console.log("📦 Parsed data:", data);

  if (!response.ok || data.error) {
      showToast(toast.error, data, t("alerts.otpVerificationFailed"));
      return;
    }
    showToast(toast.success, data, t("alerts.otpVerificationSuccess"));
          const profileToken = data.data?.profileUpdateToken;
    if (profileToken) {
      // 🔹 Set both tokens so both flows work
      dispatch(setInviteProfileUpdateToken(profileToken));
      dispatch(setProfileUpdateToken(profileToken));
    
      localStorage.setItem("inviteProfileUpdateToken", profileToken);
      localStorage.setItem("profileUpdateToken", profileToken);
    }
    dispatch(setResetToken(data.data.resetToken));
    setSeconds(60);

    setTimeout(() => {
      navigate("/create-profile");
    }, 1000);
  } catch (err) {
    console.error("❌ Exception during verification:", err);
    showToast(toast.error, err, t("alerts.otpVerificationError"));
  } finally {
    setIsVerifying(false);
  }
};



  const handleResend = async () => {
  if (!email) {
    showToast(toast.error, {
      message_en: t("otpScreen.error_missing_email"),
      message_es: t("otpScreen.error_missing_email")
    });
    return;
  }
    setIsResending(true);

    try {
      const response = await fetch(`${BASE_URL}/account-executive/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();
     if (!response.ok || data.error) {
      showToast(toast.error, data, t("alerts.otpResendFailed"));
      return;
    }

      dispatch(setOtpData({ email, otp: data.data.otp }));
    showToast(toast.success, data, t("alerts.otpResendSuccess"));
      setSeconds(60);
    } catch (err) {
    showToast(toast.error, err, t("alerts.otpResendFailed"));
    } finally {
      setIsResending(false);
    }
  };

  return (
    <Box sx={{ backgroundColor: "#EFF4F8", }}>
      {/* <Toaster /> */}
      <Box sx={{
        px: 2, display: 'flex', justifyContent: 'center',
        minHeight: "100vh", alignItems: "center",
      }}>
        <BaseCard
          maxWidth={isMobile ? '100%' : 400}
          sx={{
            width: isMobile ? '100%' : 'auto',
            px: isMobile ? 2 : 0,
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
            <img src={verify} alt="Verify Icon" />
          </Box>

          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <CustomText sx={{ ...textStyles.h4, color: theme.palette.tertiary.main }}>
              {t('verification.title')}
            </CustomText>

            <CustomText sx={{
              ...textStyles.body4,
              color: theme.palette.text.primary,
              lineHeight: 1.3,
              whiteSpace: 'pre-line'
            }}>
              {t('verification.subtitle')}
            </CustomText>

            {/* OTP Input */}
            <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
              {otpInput.map((digit, index) => (
                <TextField
                  key={index}
                  value={digit}
                  inputRef={el => inputRefs.current[index] = el}
                  onChange={(e) => handleChange(index, e.target.value)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  inputProps={{
                    maxLength: 1,
                    style: {
                      textAlign: 'center',
                      fontSize: '24px',
                      width: '45px',
                      height: '30px',
                    },
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '12px',
                      '& fieldset': {
                        borderColor: otpError && !digit
                          ? '#d32f2f' // 👈 red if error and empty
                          : digit
                            ? theme.palette.primary.main
                            : '#ccc',
                        borderWidth: otpError && !digit ? '1px' : '1px',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: theme.palette.primary.main,
                        borderWidth: '2px',
                      },
                    },
                  }}
                />
              ))}
            </Box>

            {/* Resend Section */}
            <Box sx={{ display: "flex", justifyContent: "center", mt: 1 }}>
              <CustomText sx={{ ...textStyles.body4, color: theme.palette.text.primary, textAlign: 'center' }}>
                {t("otpScreen.resend_text")}&nbsp;
                {seconds > 0 ? (
                  <Typography
                    sx={{
                      color: theme.palette.primary.main,
                      fontWeight: 500,
                      fontSize: "15px",
                      fontFamily: 'Poppins, sans-serif',
                    }}
                  >
                    {t("otpScreen.resend_in")} {seconds}s
                  </Typography>
                ) : (
                  <Typography
                    component="span"
                    onClick={handleResend}
                    sx={{
                      color: theme.palette.primary.main,
                      fontWeight: 400,
                      cursor: isResending ? 'not-allowed' : 'pointer',
                      opacity: isResending ? 0.5 : 1,
                      textDecoration: 'underline',
                      fontSize: "15px",
                      fontFamily: 'Poppins, sans-serif',
                    }}
                  >
                    {t("otpScreen.resend_action")}
                  </Typography>
                )}
              </CustomText>
            </Box>

            {/* Verify Button */}
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Button
  onClick={() => {
    console.log("✅ Button clicked!");
    handleVerify();
  }}                sx={{
                  backgroundColor: theme.palette.primary.main,
                  color: '#fff',
                  borderRadius: "6px",
                  px: 4,
                  height: 43,
                  textTransform: "none",
                  fontWeight: 300,
                  fontSize: 16,
                  fontFamily: 'Poppins, sans-serif',
                  '&:hover': {
                    backgroundColor: theme.palette.primary.dark,
                  },
                }}
              >
                {isVerifying ? (
                  <>
                    <CircularProgress size={20} thickness={4} sx={{ color: 'white' }} />
                    <span style={{ marginLeft: 8 }}>
                      {t('verification.verifyButton') || "Verifying"}
                    </span>
                  </>
                ) : (
                  t('verification.verifyButton') || "Verify Code"
                )}
              </Button>
            </Box>
          </Box>
        </BaseCard>
      </Box>
    </Box>
  );
};

export default ModalVerify;